import React, { useMemo } from 'react'

import GuideLayout from '../components/GuideLayout'
import styles from './Home.module.scss'

import useReducers from '@/store/guide'

export default React.memo(function About() {
  const [state] = useReducers()

  const post = useMemo(() => {
    return state.posts?.find(item => item.id === state.active) || {}
  }, [state])

  const html = useMemo(() => {
    if (!post.post_content) {
      return ''
    }

    const div = document.createElement('div')
    div.innerHTML = post.post_content

    return div.textContent
  }, [post])

  return (
    <GuideLayout>
      <div className={styles.title}>{post.post_title}</div>
      <div className={styles.content} dangerouslySetInnerHTML={{__html: html}}/>
    </GuideLayout>
  )
})
